module.exports = __webpack_public_path__ + "img/cash_10.de3010c3.svg";